// Compara o token atual com o último processado (persistido em
// sessionStorage, que sobrevive a reload de página mas é isolado por aba)
// para distinguir um novo login de um simples refresh da mesma sessão. Em
// caso de novo login, remove a flag de sessionStorage informada, permitindo
// que modais semanais fechados sem resposta voltem a aparecer.
//
// Usar sessionStorage (em vez de localStorage) para o marcador evita que
// um login feito em outra aba da mesma origem "vaze" e reabra o modal
// nesta aba sem ter havido login aqui.
export function resetFlagOnNewLogin(
  featureKey: string,
  sessionStorageKey: string,
  token?: string
) {
  if (!token) return;

  try {
    const lastTokenKey = `${featureKey}LastToken`;
    const lastToken = sessionStorage.getItem(lastTokenKey);

    if (lastToken === token) return;

    // Só existe token anterior para comparar depois que este código já
    // rodou ao menos uma vez nesta aba. Na primeira execução (ex.: usuário
    // já logado antes deste código existir), apenas registra a baseline,
    // sem mexer na flag — senão toda sessão já aberta seria tratada como
    // "login novo".
    if (lastToken) {
      sessionStorage.removeItem(sessionStorageKey);
    }

    sessionStorage.setItem(lastTokenKey, token);
  } catch (error) {
    // Storage bloqueado/indisponível (ex. modo privado, política do
    // navegador): não deve impedir o restante do hook de rodar.
    console.error("resetFlagOnNewLogin falhou:", error);
  }
}
